import React, { useEffect, useState } from "react";
import { Button, Card, Dropdown, Form, Image, InputGroup, Modal, Placeholder, Row, Spinner } from "react-bootstrap";
import { getTeacherInfo } from "services/Student/UserInfo.services";
import { Link, useNavigate, useParams } from "react-router-dom";
import UserClassAndGroups from "components/shared/UserClassAndGroups";
import { getAllClassesById } from "services/Teacher/Class.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import dropdown from "../../assets/dropdown.svg";
import dropdown from "../../../assets/dropdown.svg"
import placeholder from "../../../assets/schoolimage.png";

import { faEdit, faEye, faEyeSlash, faTrash } from "@fortawesome/free-solid-svg-icons";
import { deleteUser, resetPassword, updateUserInfo } from "services/Admin/UserManagement/School.service";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
const TeacherDetailPage = () => {
  const { t } = useTranslation();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingModal, setLoadingModal] = useState(false);
  const [loadingClass, setLoadingClass] = useState(false);
  const [classes, setClasses] = useState([]);
  const [groups, setGroups] = useState([]);
  const { teacherId } = useParams();
 const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showResetModal, setShowResetModal] = useState(false);
  const handleOpenResetModal = () => setShowResetModal(true);
  const handleCloseResetModal = () => setShowResetModal(false);

  const [showNameModal, setShowNameModal] = useState(false);
  const [fullName, setFullName] = useState('');
  const handleOpenNameModal = () => setShowNameModal(true);
  const handleCloseNameModal = () => setShowNameModal(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      const userResponse = await getTeacherInfo(teacherId);
      const userData = await userResponse.data.result;
      setUserData(userData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchClassesGroup = async () => {
    try {
      setLoadingClass(true);
      const response = await getAllClassesById(teacherId);
      setClasses(response?.data?.result?.classes?.data || []);
      setGroups(response?.data?.result?.groups?.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingClass(false);
    }
  };
  const onResetClick = async () => {
    if (!password || !confirmPassword) return;
    if (password.length < 8 || password.length > 20) {
      setError("Password must be minimum 8 characters & maximum 20 characters")
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoadingModal(true);
    try {
      await resetPassword(password, userData?._id); // Call API function
      setShowToast(true); // Show success toaster
      // setTimeout(() => {
      //     setShowToast(false);
      //     handleClose(); // Close modal after success
      // }, 2000);
      setShowResetModal(false);
      setPassword("");
      setConfirmPassword("");
      toast.success("Reset password successfully!", { autoClose: 2000 });
      // handleClose();
    } catch (error) {
      console.error("Error resetting password:", error);
      toast.error("Error Reseting the password.");
      setError("Failed to reset password. Try again.");
    } finally {
      setLoadingModal(false);
    }
  };
  const onSaveClick = async () => {
    if (!fullName) {
      setError("Full Name is required");
      return;
    }

    setLoadingModal(true);
    try {
      // Call API function to update user info with fullName
      await updateUserInfo(fullName, userData?._id); // Assuming updateUserInfo accepts fullName and userId
      setFullName(""); // Clear the input after successful update
      setShowNameModal(false);
      fetchData();
      toast.success("User info updated successfully!", { autoClose: 2000 });
    } catch (error) {
      console.error("Error updating user info:", error);
      toast.error("Error updating user info.");
      setError("Failed to update user info. Try again.");
    } finally {
      setLoadingModal(false);
    }
  };
  const handleDelete = async () => {
    const toastId = toast.loading("Deleting Teacher...");
    try {
      await deleteUser(userData?._id);
      toast.update(toastId, {
        render: "Teacher deleted successfully!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
      navigate(`/users/teachers`);
    } catch (error) {
      toast.update(toastId, {
        render: "Error deleting Teacher",
        type: "error",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
    }
  };
  useEffect(() => {
    fetchData();
    fetchClassesGroup();
  }, []);
  const dicebearUrl = `https://api.dicebear.com/9.x/initials/svg?seed=${userData?.fullName}`;
  return (
    <>
      <Row>

        {/* User Welcome Section with Placeholder */}
        {loading ? (
          [...Array(1)].map((_, index) => (
            <div
              style={{ minHeight: "140px", maxWidth: "500px", margin: "0px auto" }}
              className="my-3 school-cards px-4 py-4 pb-3 border-0 text-decoration-none rounded-3 shadow-lg d-flex flex-column justify-content-center align-items-center gap-3"
            >
              <Placeholder animation="glow" className="gap-2" style={{ width: "100%" }}>
                <Placeholder xs={3} size="lg" />{" "}
                <Placeholder xs={9} size="lg" />
                <Placeholder xs={12} size="lg" />
              </Placeholder>
            </div>
          ))
        ) : (
          <div
            style={{ minHeight: "140px", boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 14px 0px", maxWidth: "500px", margin: "0px auto" }}
            className="my-3 school-cards px-4 py-4 pb-3 border-0 text-decoration-none rounded-3 d-flex flex-column justify-content-center gap-3 pb-4"
          >
            <div className={`text-end`}>
              <Dropdown>
                <Dropdown.Toggle
                  className="more bg-transparent text-black border-0 e-caret-hide rounded-0"
                  id="dropdown-basic"
                >
                  <Card.Img
                    style={{ width: "24px", height: "24px" }}
                    variant="top"
                    src={dropdown}
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu
                  className="border-0"
                  style={{ boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px" }}
                >
                  <Dropdown.Item
                    onClick={handleOpenResetModal}
                  // as={Link} to={`edit-school/${id}`}
                  >
                    <FontAwesomeIcon icon={faEdit} className="me-2" />
                    {t("Reset Password")}
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={handleOpenNameModal}
                  // as={Link} to={`edit-school/${id}`}
                  >
                    <FontAwesomeIcon icon={faEdit} className="me-2" />
                    Edit Name
                  </Dropdown.Item>
                  <Dropdown.Item className="text-danger"
                    onClick={handleDelete}
                  >
                    <FontAwesomeIcon icon={faTrash} className="me-2" />
                    Delete
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div
              style={{
                borderRadius: "70%",
                overflow: "hidden",
                minWidth: "90px",
                minHeight: "90px",
                maxWidth: "90px",
                background: "#F6F6F6",
                border: "5px solid #E15455",
              }}
              className="text-center mx-auto"
            >
              <Image
                width={"100%"}
                height={"100%"}
                // src={userData?.avatar?.imageUrl?.url || userData?.imageUrl?.url}
                src={userData?.avatar?.imageUrl?.url ? userData?.avatar?.imageUrl?.url : userData?.fullName ? dicebearUrl : placeholder}
              />
            </div>
            <div
              className="d-flex align-items-center flex-column mx-auto text-center"
              style={{ color: "#5e5e5e" }}
            >
              <span style={{ fontWeight: "400", fontSize: "0.8rem", color: "#E15455", textTransform: "capitalize" }}>{userData?.role}</span>
              <h4 style={{ fontWeight: "700" }}>{userData?.fullName}</h4>
              <span style={{ fontWeight: "400", fontSize: "0.8rem" }}>{userData?.email}</span>
            </div>
          </div>
        )}
      </Row>
      <UserClassAndGroups classes={classes} groups={groups} isLoading={loadingClass} />
      <Modal show={showResetModal} onHide={handleCloseResetModal} centered size={"lg"}>
        <Modal.Header closeButton className='border-0'>
          <Modal.Title>{t("Reset")} {userData?.fullName} {t("Password")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Password Input */}
          <Form.Group>
            <Form.Label>{t("New Password")}</Form.Label>
            <InputGroup>
              <Form.Control
                type={showPassword ? 'text' : 'password'}
                placeholder={t('Enter new password')}
                className='px-3 py-2 border-right-0'
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError(""); // Clear error on input change
                }}
              />
              <InputGroup.Text style={{ cursor: 'pointer' }} onClick={() => setShowPassword(!showPassword)}>
                <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
              </InputGroup.Text>
            </InputGroup>
          </Form.Group>

          {/* Confirm Password Input */}
          <Form.Group className="mt-3">
            <Form.Label>{t("Confirm Password")}</Form.Label>
            <InputGroup>
              <Form.Control
                type={showConfirmPassword ? 'text' : 'password'}
                placeholder={t('Confirm new password')}
                className='px-3 py-2 border-right-0'
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  setError(""); // Clear error on input change
                }}
              />
              <InputGroup.Text style={{ cursor: 'pointer' }} onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                <FontAwesomeIcon icon={showConfirmPassword ? faEye : faEyeSlash} />
              </InputGroup.Text>
            </InputGroup>
            {error && <small className="text-danger mt-1">{error}</small>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className='border-0 justify-content-between'>
          <Button variant="secondary" className='mt-1 px-4 button-style py-2 border-0' style={{ background: "linear-gradient(270deg, #272727 0%, #4B4B4B 100%)" }} onClick={handleCloseResetModal} disabled={loadingModal}>
            {t("Cancel")}
          </Button>
          <Button variant="primary" className='mt-1 px-4 button-style py-2 border-0' onClick={onResetClick} disabled={!password || !confirmPassword || loadingModal}>
            {loadingModal ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : "Reset"}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showNameModal} onHide={handleCloseNameModal} centered size={"lg"}>
        <Modal.Header closeButton className="border-0">
          <Modal.Title>{t("Edit")} {userData?.fullName} {t("Info")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Full Name Input */}
          <Form.Group>
            <Form.Label>{t("Full Name")}</Form.Label>
            <Form.Control
              type="text"
              placeholder={t("Enter new full name")}
              className="px-3 py-2"
              value={fullName}
              onChange={(e) => {
                setFullName(e.target.value);
                setError(""); // Clear error on input change
              }}
            />
            {error && <small className="text-danger mt-1">{error}</small>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-between">
          <Button
            variant="secondary"
            className="mt-1 px-4 button-style py-2 border-0"
            style={{ background: "linear-gradient(270deg, #272727 0%, #4B4B4B 100%)" }}
            onClick={handleCloseNameModal}
            disabled={loadingModal}
          >
            {t("Cancel")}
          </Button>
          <Button
            variant="primary"
            className="mt-1 px-4 button-style py-2 border-0"
            onClick={onSaveClick}
            disabled={!fullName || loadingModal}
          >
            {loadingModal ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : t("Save")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TeacherDetailPage;
